import { AlarmAndInfraction } from '../models/alarmAndInfraction.entity';
/**
 * Reviewed By Rafael
 * 03-12-18
 */
import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { AuthenticationService } from 'app/pages/login/authentication.service';
import { SelectItem } from 'primeng/primeng';
import { BehaviorSubject, Observable, from, throwError as observableThrowError, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ConfigService } from '../config/config.service';
import { Alarm, AlarmType } from '../models';
import { DefaultFilter } from '../models/defaultFilter.entity';
import { FilterAlarms } from '../models/filter.alarms.entity';
import { PictureAndMovie } from '../models/pictureAndMovie.entity';
import { DataService } from './data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LinkedAlarms } from '../models/linkedAlarms.entity';
import { AiAlarmValidation } from '../models/aiAlarmValidation.entity';



@Injectable()
export class AlarmService {

  private baseUrl;
  private cache = new Map<string, { data: Alarm[], timestamp: number }>();
  private cacheTtl = 60000; // 1 min

  public emailsLogs = new BehaviorSubject<boolean|null>(null)

  constructor(private http: HttpClient, 
      private configService: ConfigService,      
      private dataService: DataService,  
      protected auth: AuthenticationService
    ) { 
      this.baseUrl = configService.getApiURI();
  }

  public filterApplyAlarms(_filter: FilterAlarms, alarms: Alarm[]): Alarm[] {
     let _result = new Array<Alarm>();
     _result = alarms.filter(alarm => {
let _result_: boolean = false,
        customer = (alarm.driverId)? this.dataService.getCustomerByDriverId(alarm.driverId) : null;
        
        if (customer && _filter.selectedCustomers && _filter.selectedCustomers
         .find(customerChildId => customerChildId === customer.customerChildId)) {
          _result_ = true;
        };

       if (_filter.selectedDrivers && _filter.selectedDrivers.length > 0) {
         if (_filter.selectedDrivers.find(driverId => driverId === alarm.driverId)) 
           _result_ = true;
         else 
           _result_ = false;
       }

        if (_result_ && alarm.datetime && _filter.selectedDateStart && _filter.selectedDateEnd) {
          _result_ = (alarm.datetime >= _filter.selectedDateStart && alarm.datetime <= _filter.selectedDateEnd);
        }
       
       return _result_;
     });
     return _result;
  }

  /**
   * Retorna os Alertas com os Filtros incluindo os Alarm Types
   * @param _filter Filtros Setados
   */
  public getAlarmsByFilter(_filter: FilterAlarms):  Observable<Alarm[]>  {
    let _ws = this.configService.webServices['alarmTypesByFilter'];
    
    return this.http.get<Alarm[]>(_ws.url(this.baseUrl, _filter), {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError));       
  }

  public getAlarmsByFilterDefault(_filter: DefaultFilter, useCache:boolean = false): Observable<Alarm[]> {
    const cacheKey = JSON.stringify(_filter);
    const now = Date.now();

    if (this.cache.has(cacheKey) && useCache === true) {
        const cachedResponse = this.cache.get(cacheKey);
        if (cachedResponse && (now - cachedResponse.timestamp < this.cacheTtl)) {
            return of(cachedResponse.data);
        }
    }
    let _ws = this.configService.webServices['alarmTypesByFilterDefault'];
    return this.http.post<Alarm[]>(_ws.url(this.baseUrl, _filter), _filter, { headers: this.getHttpHeaders() }).pipe(
        map((res) => {
            const data = res;
            this.cache.set(cacheKey, { data, timestamp: now });
            return data;
        }),
        catchError(this.handleError),
    );
  }

  public getAlarmsByFilterDefaultV3(_filter: DefaultFilter, useCache = false): Observable<Alarm[]> {
    const cacheKeyPrefix = 'alarmsv3';

    if (useCache) {
      const cacheKey = this.buildCacheKey(cacheKeyPrefix, _filter);
      const cachedResponse = this.cache.get(cacheKey);

      if (cachedResponse && Date.now() - cachedResponse.timestamp < this.cacheTtl) {
        return of(cachedResponse.data);
      }
    }

    const webService = this.configService.webServices['alarmTypesByFilterDefaultV3'];

    return this.http.post<Alarm[]>(webService.url(this.baseUrl, _filter), _filter, { headers: this.getHttpHeaders() })
      .pipe(
        tap(data => {
          if (useCache) {
            const cacheKey = this.buildCacheKey(cacheKeyPrefix, _filter);
            this.cache.set(cacheKey, { data, timestamp: Date.now() });
          }
        }),
        catchError(this.handleError),
      );
  }

  private buildCacheKey(prefix: string, filter: DefaultFilter): string {
     return prefix + JSON.stringify(filter);
  }


  public getAlarmsAuditByFilter(_filter: FilterAlarms):  Observable<Alarm[]>  {
    let _ws = this.configService.webServices['auditByFilters'];

    return this.http.get<Alarm[]>(_ws.url(this.baseUrl, _filter), {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError),); 
  }

  public getAlarmsAuditByFilterDefault(_filter: DefaultFilter):  Observable<Alarm[]>  {
    let _ws = this.configService.webServices['auditByFilterDefault'];

    return this.http.post<Alarm[]>(_ws.url(this.baseUrl, _filter), _filter, {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError),); 
  }

  public getAlarmsAuditAndInfractionsByFilterDefault(_filter: DefaultFilter):  Observable<AlarmAndInfraction>  {
    let _ws = this.configService.webServices['auditAndInfractionsByFilterDefault'];

    return this.http.post<AlarmAndInfraction>(_ws.url(this.baseUrl, _filter), _filter, {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError),); 
  }

  public getAlarmsAndInfractionsDefault(_filter: DefaultFilter):  Observable<AlarmAndInfraction>  {
    let _ws = this.configService.webServices['alarmsAndInfractionsDefault'];

    return this.http.post<AlarmAndInfraction>(_ws.url(this.baseUrl), _filter, {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError)); 
  }

  public getPictureByAlarm(alarmId : number): Observable<PictureAndMovie> {
    let _ws = this.configService.webServices['pictureByAlarm'];

    return this.http.get<PictureAndMovie>(_ws.url(this.baseUrl, alarmId), {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError));
  }

  public getAlarmsByInterval(_filter: FilterAlarms):  Observable<Alarm[]>  {
    let _ws = this.configService.webServices['alarmsByInterval'];

    return this.http.get<Alarm[]>(_ws.url(this.baseUrl, _filter), {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError)); 
  }

  public getAlarms():  Observable<Alarm[]> {
    return this.http.get<Alarm[]>(this.configService.wsServicesUrl('alarms'), {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError)); 
  } 

  public getAlarmTypes():  Observable<AlarmType[]>  {
    let _ws = this.configService.webServices['alarmTypes'];

    return this.http.get<AlarmType[]>(_ws.url(this.baseUrl), {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError)); 
  }

  public setReadAlarm(alarmIds: number[], timezone?: string):  Observable<Alarm[]>  {
    let _ws = this.configService.webServices['setAlarmRead'];
    const url = _ws.url(this.baseUrl) + (timezone != null && timezone !== '' ? '?timezone=' + encodeURIComponent(timezone) : '');
    return this.http.put<Alarm[]>(url, alarmIds, {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError));
  }

  public setTreatmentStarted(alarmIds: number[], startOrStop: boolean):  Observable<void>  {
    let _ws = this.configService.webServices['setTreatmentStarted'];
  
    return this.http.put<void>(_ws.url(this.baseUrl, startOrStop), alarmIds, {headers: this.getHttpHeaders()}).pipe(catchError(this.handleError));     
  }

  public getAlarmTypesSelectItem(_alarmTypes: AlarmType[]): SelectItem[] {
    let _result: SelectItem[] = [];
    _alarmTypes.forEach((alarmType:AlarmType) => {
    _result.push({label: alarmType.name, value: alarmType.id});
    });
   
    return _result;
  }

  public deleteAlarm(id: number):  Observable<void> {
    return this.http.delete<void>(this.baseUrl + '/api/todos/' + id, {headers: this.getHttpHeaders()})
    .pipe(catchError(this.handleError)); 
  }

  public createAlarm(alarmData: Alarm): Observable<Alarm> {
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.post<Alarm>(this.baseUrl + '/api/alarms/',{  
              headers: headers
            }).pipe(catchError(this.handleError)); 
  }
  
  public updateAlarm(alarmData: Alarm): Observable<Alarm> {
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.put<Alarm>(this.baseUrl + '/api/todos/' + alarmData.id, {  
      headers: headers
    }).pipe(catchError(this.handleError)); 
  }

  public novaRevisaoAuditoria(auditId: number, obs: string, aproved: boolean) {
    let _ws = this.configService.webServices['novaRevisao'];
    
    return this.http.post(_ws.url(this.baseUrl), { auditId, statusId: (aproved) ? 3 : 4, obs }, { headers: this.getHttpHeaders() })
    .pipe(catchError(this.handleError));
  }

  public deleteImgSignature(signatureId: number) {
    let _ws = this.configService.webServices['deleteImgSignature'];
    
    return this.http.delete(_ws.url(this.baseUrl)+`/v2/audit/driver-signature/${signatureId}`, { headers: this.getHttpHeaders() })
    .pipe(catchError(this.handleError));
  }

  public updateReadByCustomer(alarmId: number) {
    let _ws = this.configService.webServices['readByCustomer'];
    return this.http.patch(_ws.url(this.baseUrl, alarmId), {}, { headers: this.getHttpHeaders() })
    .pipe(catchError(this.handleError));
  }

  public buscaRevisoesByAlarm(alarmId: number){
    let _ws = this.configService.webServices['buscaRevisoesAuditoria'];
    
    return this.http.get(_ws.url(this.baseUrl, alarmId), { headers: this.getHttpHeaders() })
    .pipe(catchError(this.handleError));
  }

  public getAuditHistories(alarmId: number): Observable<any> {
    let webService = this.configService.webServices['getAlarmAuditHistories'];

    let url = webService.url(this.baseUrl, alarmId)
    let requestConfig = { headers: this.getHttpHeaders() }

    return this.http.get(url, requestConfig).pipe(
      catchError(this.handleError)
    );
  }

  public getAlarmsAuditHistories(alarmsIds: number[]): Observable<any> {
    let webService = this.configService.webServices['getAlarmsAuditHistories'];

    let url = webService.url(this.baseUrl)
    let requestConfig = { headers: this.getHttpHeaders() }

    return this.http.post(url, alarmsIds, requestConfig).pipe(
      catchError(this.handleError)
    );
  }

  public getHistoryByImeiAndReferenceDate(imei: String, vehicleId: number, referenceDate: String ): Observable<any> {
    let webService = this.configService.webServicesV2['getHistoryByImeiAndReferenceDate'];

    let url = webService.url(this.baseUrl, imei, vehicleId, referenceDate );
    let requestConfig = { headers: this.getHttpHeaders() }

    return this.http.get(url, requestConfig).pipe(
        catchError(this.handleError)
    );
  }


  public getEmailLog(alarmId: number): Observable<any> {
    let webService = this.configService.webServices['getEmailLog'];
    let url = webService.url(this.baseUrl, alarmId)
    let requestConfig = { headers: this.getHttpHeaders() }

    return this.http.get(url, requestConfig).pipe(
      catchError(this.handleError)
    );
  }

  public getAlarmByEmail(emailLogId: number) {
    let webService = this.configService.webServices['getAlarmByEmail'];
    let url = webService.url(this.baseUrl, emailLogId)
    let requestConfig = { headers: this.getHttpHeaders() }

    return this.http.get<any>(url, requestConfig).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: any) {
    let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('Erro:', error);
    return observableThrowError(errMsg);
  }

  getHttpHeaders() : HttpHeaders {
    const token = this.auth.getToken();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token || ''
    });

    return headers;
  }

  public countAuditGroupDisk(filter: DefaultFilter): Observable<any> {
    let _ws = this.configService.webServices['countAuditGroupDisk'];

    return this.http.post(_ws.url(this.baseUrl), filter).pipe(catchError(this.handleError))
  }

  public getLastAlarm(imeis: string[]): Promise<any[]> {
    return new Promise((resolve, reject) => {
      let _ws = this.configService.webServices['lastAlarm'];
      
      this.http.post(_ws.url(this.baseUrl), imeis, { headers: this.getHttpHeaders() })
      .pipe(catchError(this.handleError))
    })
  }
  
  public getLastValidAlarm(imeis: string[]): Promise<any[]> {
    return new Promise((resolve, reject) => {
      let _ws = this.configService.webServices['lastValidAlarm'];
      
      this.http.post<any[]>(_ws.url(this.baseUrl), imeis, { headers: this.getHttpHeaders() }).subscribe(res => resolve(res), err => reject(err))
    })
  }
  
  public getUpdatedAlarmsDataAfterCompletion(auditIds: number[]): Promise<Alarm[]> {
    const _ws = this.configService.webServices['updatedAlarmsByAuditId'];
    const url = _ws.url(this.baseUrl);
    const headers = { headers: this.getHttpHeaders() };

    return this.http
      .post<Alarm[]>(url, auditIds, headers)
      .toPromise()
      .catch(err => Promise.reject(err));
  }

  public getDataForChartLastVelocitiesAndAlarms(vehicleId: number, driverId: number, startDate: Date, endDate: Date): Observable<any> {
    let webService = this.configService.webServices['getDataForChartLastVelocitiesAndAlarms'];
    let url = webService.url(this.baseUrl, vehicleId, driverId, startDate, endDate)
    let requestConfig = { headers: this.getHttpHeaders() }

    return this.http.get(url, requestConfig).pipe(
      catchError(this.handleError)
    );
  }

  public getAlarmsTypeByCustomerId(customerId: number) {
    let webService = this.configService.webServices['getAlarmsTypeByCustomerId'];
    let url = webService.url(this.baseUrl, customerId)
    let requestConfig = { headers: this.getHttpHeaders() }

    return this.http.get(url.toString(), requestConfig).pipe(
      catchError(this.handleError)
    );
  }

  public setAlarmReadByCustomer(alarmId: number, userId: number): Observable<any> {
    const data = { userId, alarmId }
    const _ws = this.configService.webServices['setAlarmReadByCustomer'];
    const url = _ws.url(this.baseUrl)

    return this.http.patch(url, data, { headers: this.getHttpHeaders() })
    .pipe(
      catchError(this.handleError)
    )
  }

  emailsLogsObservable() {
    return this.emailsLogs.asObservable();
  }

  public getLinkedAlarms(alarmIdList: number[]):Observable<LinkedAlarms[]>{
    if(alarmIdList.length==0)return from([]);
    const _ws = this.configService.webServices['getLinkedAlarms'];
    const url = _ws.url(this.baseUrl, alarmIdList)

    return this.http.get<LinkedAlarms[]>(url, { headers: this.getHttpHeaders() }).pipe(
      map((res) => {
        let linkedAlarms =  res
        linkedAlarms.forEach((linkedAlarm) => {
          const indexOfAlarmType = this.dataService.alarmTypesNumber.findIndex(type => type.value == linkedAlarm.linkedAlarm.typeAlarm)
          if (indexOfAlarmType != -1) {
            const alarmType = this.dataService.alarmTypesNumber[indexOfAlarmType];
            linkedAlarm.linkedAlarm.typeAlarmDescription = alarmType.label
            linkedAlarm.linkedAlarm.iconPath = alarmType.icon;
          }
          if(linkedAlarm.linkedAlarm.urlPictures[0]=='NO_PICTURE'){
            linkedAlarm.linkedAlarm.picture='NO_PICTURE';
          }
        })
        return linkedAlarms;
      }),
      catchError(this.handleError)
    )
  }

  public getAiAlarmValidationsByAlarmIds(alarmIds: number[]): Observable<AiAlarmValidation[]> {
    const _ws = this.configService.webServicesV2['getAiAlarmValidationsByAlarmIds'];
    const url = _ws.url(this.baseUrl, alarmIds)

    return this.http.get<AiAlarmValidation[]>(url, { headers: this.getHttpHeaders() }).pipe(
      catchError(this.handleError)
    )
  }
}
